import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.75 12A8.226 8.226 0 0 0 12 20.25c4.575 0 4.8-1.125 6.375-3H14.25l1.5-1.5H21V21l-1.5 1.5v-4.275c-1.8 2.25-4.575 3.525-7.5 3.525A9.73 9.73 0 0 1 2.25 12h1.5Zm.75-6.225C6.3 3.525 9.075 2.25 12 2.25c5.4 0 9.75 4.35 9.75 9.75h-1.5A8.226 8.226 0 0 0 12 3.75c-4.575 0-4.8 1.125-6.375 3H9.75l-1.5 1.5H3V3l1.5-1.5v4.275Z" })
});
export default SvgRefresh;
